import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import SplineChart from "./SplineChart";
import { api, endpoint } from "../../api";
import { Spin } from "antd";

const BarChart = ({ data, isLoading = false, setIsLoading }) => {
  const { userDetails } = useSelector((state) => state.user);
  const [graphData, setGraphData] = useState([])


  const { chartType, chartTitle, locations, xAxis } = data

  // get device data
  const getDeviceChartData = async () => {
    const body = { device: locations[0].device, yAxis: locations[0].yAxis, unit: xAxis.unit }
    const data = await api.get(endpoint.get_device_chart, {
      params: body,
    })
    console.log('bar', { data })
    if (data.success) {
      setGraphData(data?.results)
    }
    setIsLoading(false)
  }
  // get location data
  const getLocationChartData = async () => {
    const body = locations.map(item => ({ location: item.location, yAxis: item.yAxis }))
    const data = await api.get(endpoint.get_location_chart, {
      params: { locations: body },
    })
    console.log('bar1', { data })
    if (data.success) {
      setGraphData(data?.results)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    setIsLoading(true)
    if (chartType === 'Device Chart') {
      getDeviceChartData()
    } else {
      getLocationChartData()
    }

  }, [chartType])


  return (
    <div className="p-3">
      <Spin spinning={isLoading}>
        {
          graphData.length > 0 ? <SplineChart
            title={chartTitle}
            data={graphData}
            chartType={chartType}
            type="column"
          /> : 'No data found'
        }
      </Spin>

    </div>
  );
};

export default BarChart;
